import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

// Styled components for aesthetic design
const StyledTableCell = styled(TableCell)({
  backgroundColor: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
  color: 'black',
  fontWeight: 'bold',
});

const StyledTableRow = styled(TableRow)({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)', // Light grey background for odd rows
  },
});

const data = [
  { age: "2", class: "Play group", section: "IB PYP" },
  { age: "3", class: "Nursery", section: "IB PYP" },
  { age: "4", class: "Pre-Kindergarten (Pre-K)", section: "IB PYP" },
  { age: "5", class: "Kindergarten (K)", section: "IB PYP" },
  { age: "6", class: "Year 1 (PYP 1)", section: "IB PYP" },
  { age: "7", class: "Year 2 (PYP 2)", section: "IB PYP" },
  { age: "8", class: "Year 3 (PYP 3)", section: "IB PYP" },
  { age: "9", class: "Year 4 (PYP 4)", section: "IB PYP" },
  { age: "10", class: "Year 5 (PYP 5)", section: "IB PYP" },
  { age: "11", class: "Year 6 (MYP 1)", section: "IB MYP" },
  { age: "12", class: "Year 7 (MYP 2)", section: "IB MYP" },
  { age: "13", class: "Year 8 (MYP 3)", section: "IB MYP" },
  { age: "14", class: "Year 9 (MYP 4)", section: "IB MYP" },
  { age: "15", class: "Year 10 (MYP 5)", section: "IB MYP" },
  { age: "16", class: "Year 11 (DP 1)", section: "IB DP" },
  { age: "17+", class: "Year 12 (DP 2)", section: "IB DP" }
];

const AgeChart = () => {
  const navigate = useNavigate();
  
  return (
    <Box sx={{ p: 2 }}>
      <Button
        variant="text"
        startIcon={<ArrowBackIcon sx={{ color: 'blue' }} />}
        onClick={() => navigate(-1)}
        sx={{
          mb: 2,
          color: 'blue',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 255, 0.1)', // Light blue background on hover
          },
        }}
      >
        Back to Previous Page
      </Button>
      <Typography variant="h4" component="h1" gutterBottom>
        Age Chart Guide
      </Typography>
      <Typography variant="body1" gutterBottom>
        Students will be placed in their age appropriate year group which includes the Primary Years Programme (PYP), Middle Programme (MYP) and the IB Diploma (DP).
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Age as on 1st August</StyledTableCell>
              <StyledTableCell>Class</StyledTableCell>
              <StyledTableCell>Section</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <StyledTableRow key={index}>
                <TableCell>{row.age}</TableCell>
                <TableCell>{row.class}</TableCell>
                <TableCell>{row.section}</TableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AgeChart;
